// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "object.pdf-document[data-v-3c332e28],\nembeb.pdf-document[data-v-3c332e28] {\n  width: 100% !important;\n  height: 100% !important;\n}", ""]);
// Exports
module.exports = exports;
